import moment from 'moment';
import { allServicesCategories, allStatusListItems, allSubServices } from "../../../data/CategoriesData";
import OrderDetials from "../../orders/OrderDetials";
import Pagination from "../../../utilities/Pagination"
import { handlePDFClick } from "../../../utilities/handleFunctions/HandlePDFOpen"
import { useAdminService } from '../../../context/Admins/AdminServiceContext';
import { useAdmin } from '../../../context/Admins/AdminContext';
import { useAdminAllUsers } from '../../../context/Admins/AdminAllUsersContext';

export function SettingServices() {
    const { loading, currentPage, setCurrentPage, searchQuery, setSearchQuery,
        setSelectedStatus, selectedStatus, serviceData } = useAdminService();
    const { allUsersData } = useAdminAllUsers();
    const { profile } = useAdmin();
    const totalPages = serviceData?.data?.paginationInfo.totalPagesCount;

    const AdminService = ({ orderId, serviceName, serviceId, numberOfForms, language, orderDescription, orderCreated, orderUser, subServices, orderStatus, orderStatusEn, offerStatus, offerFile, offerNote, offerPrice, customerEmail, customerName, customerPhone, adminRole, offerStatusEn }) => (
        <tr
            className={`${orderStatusEn === "Rejected"
                && "table-danger"} ${orderStatusEn === "Pending"
                && "table-warning"}`}>
            <td className="col" > {`${moment(orderCreated).format('YY')}${new Intl.NumberFormat("en-IN", { minimumIntegerDigits: 2 }).format(
                serviceId,)}${new Intl.NumberFormat("en-IN", { minimumIntegerDigits: 3 }).format(orderId,)}`
            }</td>
            <td className="col">
                {moment(orderCreated).format('Do MMM YYYY')}</td>
            <td className="col">{serviceName}</td>
            <td className="col">{orderUser}
                {/* <br /><span className="text-decoration-underline c-lightBeige">{orderUserID}</span> */}
            </td>
            <td className="col">
                <button
                    className="btn-masar-sm btn-light-beige " data-bs-toggle="modal" data-bs-target={`#order-details-${orderId}`}>
                    عرض الطلب</button>
                <button className={`${offerFile ? "btn-dark-orange" : "btn-med-gray"} btn-masar-sm m-1`} onClick={handlePDFClick} value={offerFile} disabled={!offerFile}>{!offerFile ? <span className="text-decoration-line-through">PDF</span> : "PDF"}</button>

                <OrderDetials
                    offerStatus={offerStatus}
                    orderId={orderId}
                    numberOfForms={numberOfForms}
                    language={language}
                    orderDescription={orderDescription}
                    subServices={subServices}
                    orderStatus={orderStatus}
                    offerNote={offerNote}
                    offerPrice={offerPrice}
                    serviceName={serviceName}
                    offerFile={offerFile}
                    customerEmail={customerEmail}
                    customerName={customerName}
                    customerPhone={customerPhone}
                    adminRole={adminRole}
                />
            </td>
            <td className={`col ${orderStatusEn === "Paid" ? "text-success" : ""}`}>{orderStatusEn === "Paid" ? "تم الدفع" : offerStatus} {offerStatusEn === "Pending" && offerFile ?
                <span className="badge bg-info">للمراجعة</span> :
                (orderStatusEn === "Rejected" ?
                    <span className="badge bg-danger">مرفوض</span> : "")}</td>
        </tr>
    );
    // const handleStatusChange = 
    // }

    // const handleSearchChange 

    const filteredServiceData = serviceData?.data?.result.filter(item =>
        item.user.firstName.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.user.lastName.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.description.toLowerCase().includes(searchQuery.toLowerCase())
        // item.status.toLowerCase().includes(searchQuery) ||
        // item.id.toString().includes(searchQuery) ||
        // // item.createdAt.includes(searchQuery)
        // item.offerDetails.price.toString().includes(searchQuery)
        // item.offerDetails?.status.toLowerCase().includes(searchQuery) ||
    );

    if (!serviceData) return <div className="loader" role="status" aria-live="polite" aria-label="Loading"></div>;


    moment.locale('en');

    return (
        <div className="container my-3 rounded bg-light-gray position-relative p-3">
            <div className="d-flex flex-wrap justify-content-center">
                <input
                    name="queryServices"
                    className="form-control-sm border-0 w-auto"
                    type="search"
                    placeholder="بحث"
                    value={searchQuery}
                    onChange={(e) => {
                        setSearchQuery(e.target.value);
                    }} />
                <div className="container mt-1 position-relative pt-3 px-2 overflow-auto">
                    <div className="form-floating">
                        <select className="form-select form-select-sm w-75 mb-2"
                            id="select-status"
                            onChange={(e) => {
                                setSelectedStatus(e.target.value);
                            }}
                            defaultValue={selectedStatus}
                        >
                            <option value="">الكل</option>
                            {allStatusListItems.map((oneStatus, index) =>
                                <option key={index} value={oneStatus.en}>{oneStatus.ar}</option>
                            )}
                        </select>
                        <label htmlFor="select-status text-start">حالة الطلب لدى العميل</label>
                    </div>
                    {loading ?
                        <div className="loader" role="status" aria-live="polite" aria-label="Loading"></div>
                        :
                        <table className="table table-hover">
                            <thead className="table-dark">
                                <tr>
                                    <th scope="col">كود الطلب</th>
                                    <th scope="col">التاريخ</th>
                                    <th scope="col">الخدمة</th>
                                    <th scope="col">العميل</th>
                                    <th scope="col">الإجراءات</th>
                                    <th scope="col">موافقة المشرف</th>
                                </tr>
                            </thead>
                            <tbody>
                                {(searchQuery ? filteredServiceData : serviceData?.data?.result).map((order) => (
                                    <AdminService
                                        key={order.id}
                                        orderId={order.id}
                                        orderCreated={order.createdAt}
                                        serviceId={order.service.id}
                                        serviceName={allServicesCategories.map(cat => cat.en === order.service.name ? cat.ar : "")}
                                        orderUser={order.user.firstName + " " + order.user.lastName}
                                        orderUserID={order.user.id}
                                        orderStatusEn={order.status}
                                        orderStatus={allStatusListItems.map(oneStatus => oneStatus.en === order.status ? oneStatus.ar : "")}
                                        numberOfForms={order.numberOfForms}
                                        language={order.language}
                                        orderDescription={order.description}
                                        subServices={order.subServices &&
                                            order.subServices.map((e, index) => {
                                                const matchedSubService = allSubServices.find(subServ => subServ.en === e);
                                                return matchedSubService ? (index > 0 ? " - " : "") + matchedSubService.ar : "";
                                            }).filter(Boolean)
                                        }
                                        offerStatus={allStatusListItems.map(oneStatus => oneStatus.en === order.offerDetails?.status ? oneStatus.ar : "")}
                                        offerStatusEn={order.offerDetails?.status}
                                        offerFile={order.offerDetails?.file}
                                        offerPrice={order.offerDetails?.price}
                                        offerNote={order.offerDetails?.notes}
                                        customerEmail={order.user.email}
                                        customerName={order.user.firstName + " " + order.user.lastName}
                                        customerPhone={allUsersData?.data?.result.find(userData =>
                                            order?.user?.id === userData?.id)?.mobilePhone || ""}
                                        adminRole={profile?.data?.role}
                                    />
                                ))}
                            </tbody>
                        </table>}
                    {!searchQuery ? (totalPages > 1) &&
                        <Pagination
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                            totalPages={totalPages} />
                        : ""}
                </div>

            </div>
        </div>
    )
}